import CommitCard from './CommitCard';
export default CommitCard;